define('home/views/SearchResultsView',[
    'home/views/common/TabbedView',
    'home/views/ForumCardCollectionView',
    'home/views/UserCollectionView',
    'home/views/FeedEmptyView',
    'home/views/ActivityCardWrapperView',
    'home/views/PostCollectionView',

    'home/views/ActivityCardCollectionView',

    'home/templates/searchResults',
], function (
    TabbedView,
    ForumCardCollectionView,
    UserCollectionView,
    FeedEmptyView,
    ActivityCardWrapperView,
    PostCollectionView,

    ActivityCardCollectionView,

    searchResultsTemplate
) {
    'use strict';

    return TabbedView.extend({
        defaultTab: 'threads',

        template: searchResultsTemplate,

        getTabView: function (tab) {
            var feed = this.model[tab];

            switch (tab) {
            case 'threads':
                return new ActivityCardCollectionView({
                    itemView: ActivityCardWrapperView.extend({ className: 'card' }),
                    model: feed,
                    collection: feed.get('items'),
                });
            case 'forums':
                return new ForumCardCollectionView({
                    emptyView: FeedEmptyView,
                    model: feed,
                    collection: feed.get('items'),
                });
            case 'users':
                return new UserCollectionView({
                    emptyView: FeedEmptyView,
                    model: feed,
                    collection: feed.get('items'),
                });
            case 'posts':
                return new PostCollectionView({
                    className: 'cards',
                    emptyView: FeedEmptyView,
                    model: feed,
                    collection: feed.get('items'),
                });
            case 'myposts':
                return new PostCollectionView({
                    className: 'cards',
                    emptyView: FeedEmptyView,
                    model: feed,
                    collection: feed.get('items'),
                });
            }
        },
    });
});

